/**
 * Formats a timestamp into a readable date string
 */
export const formatDate = (timestamp: number): string => {
	if (!timestamp) return 'N/A';

	const date = new Date(timestamp);

	// Format: Month Day, Year Hour:Minute AM/PM
	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit'
	});
};

/**
 * Converts a Date object to Unix timestamp (seconds)
 */
export const dateToUnixTimestamp = (date: Date): number => {
	return Math.floor(date.getTime() / 1000);
};

export enum EBonusMoneyLambdaURL {
	LIST_LAMBDA_REQUEST_DATA = '/dashboard/listBonusMoneyLambdaRequest/dashboard-bonusMoneyLambda-listBonusMoneyLambdaRequest',
	UPDATE_LAMBDA_REQUEST_STATUS = '/dashboard/updateBonusMoneyLambdaRequestStatus/dashboard-bonusMoneyLambda-updateBonusMoneyLambdaRequestStatus'
}

export enum EBonusMoneyLambdaReqStatus {
	PENDING = 'pending',
	APPROVED = 'approved',
	REJECTED = 'rejected',
	SCHEDULED = 'scheduled',
	PROCESSING = 'processing',
	UPLOADED = 'uploaded',
	FAILED = 'failed'
}

export const COL_NAMES = {
	index: 'index',
	actions: 'actions',
	eventName: 'eventName',
	status: 'status',
	cashbackDenomInRs: 'cashbackDenomInRs',
	bonusDenomInRs: 'bonusDenomInRs',
	totalUserCount: 'totalUserCount',
	totalBonusAmountInRs: 'totalBonusAmountInRs',
	totalCashbackAmountInRs: 'totalCashbackAmountInRs',
	bonusExpiryTime: 'bonusExpiryTime',
	cashbackExpiryTime: 'cashbackExpiryTime',
	approvedBy: 'approvedBy',
	approvedAt: 'approvedAt',
	scheduledBy: 'scheduledBy',
	scheduledAt: 'scheduledAt',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	cronExpression: 'cronExpression',
	fileName: 'fileName',
	s3Path: 's3Path'
};

// Columns that can be filtered
export const FILTERABLE_COLUMNS = [
	COL_NAMES.eventName,
	COL_NAMES.status,
	COL_NAMES.approvedBy,
	COL_NAMES.scheduledBy,
	COL_NAMES.createdAt,
	COL_NAMES.updatedAt
];

// Columns that can be sorted
export const SORTABLE_COLUMNS = [
	COL_NAMES.eventName,
	COL_NAMES.status,
	COL_NAMES.totalUserCount,
	COL_NAMES.bonusDenomInRs,
	COL_NAMES.cashbackDenomInRs,
	COL_NAMES.createdAt,
	COL_NAMES.approvedAt,
	COL_NAMES.scheduledBy,
	COL_NAMES.scheduledAt,
	COL_NAMES.approvedBy,
	COL_NAMES.bonusExpiryTime,
	COL_NAMES.cashbackExpiryTime,
	COL_NAMES.totalBonusAmountInRs,
	COL_NAMES.totalCashbackAmountInRs,
	COL_NAMES.updatedAt
];
